import {
  Directive,
  HostBinding,
  HostListener,
  Inject,
  Optional,
  NgZone,
  OnInit,
  ElementRef,
  ViewContainerRef,
  AfterViewInit,
  Input,
} from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MAT_TOOLTIP_SCROLL_STRATEGY,
  MatTooltip,
  MatTooltipDefaultOptions,
} from '@angular/material/tooltip';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher, ScrollStrategy } from '@angular/cdk/overlay';
import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Platform } from '@angular/cdk/platform';

@Directive({
    selector: '[cropText]',
    standalone: false
})
export class CropTextDirective extends MatTooltip implements OnInit, AfterViewInit {
  @Input('cropText')
  public textForTooltip?: string;

  @HostBinding('class') elementClass: string;

  @HostListener('mouseenter') onMouseenter(): void {
    if (this.isTextCropped()) {
      this.message = this.textForTooltip || this.elementRef.nativeElement.innerText;
      this.show();
    }
  }

  @HostListener('mouseleave') onMouseleave(): void {
    if (this.isTextCropped()) {
      this.hide();
    }
  }

  constructor(
    overlay: Overlay,
    scrollDispatcher: ScrollDispatcher,
    viewContainerRef: ViewContainerRef,
    ngZone: NgZone,
    platform: Platform,
    ariaDescriber: AriaDescriber,
    focusMonitor: FocusMonitor,
    @Optional() dir: Directionality,
    @Optional()
    @Inject(MAT_TOOLTIP_SCROLL_STRATEGY)
    scrollStrategy: ScrollStrategy,
    @Inject(MAT_TOOLTIP_DEFAULT_OPTIONS)
    defaultOptions: MatTooltipDefaultOptions,
    private elementRef: ElementRef,
  ) {
    super(
      overlay,
      elementRef,
      scrollDispatcher,
      viewContainerRef,
      ngZone,
      platform,
      ariaDescriber,
      focusMonitor,
      scrollStrategy,
      dir,
      defaultOptions,
      {},
    );
  }

  ngOnInit(): void {
    this.elementClass = 'cropped';
  }

  // overwriting ngAfterViewInit() to prevent unnecessary logic from super class
  // eslint-disable-next-line
  ngAfterViewInit(): void {}

  private isTextCropped(): boolean {
    const { offsetWidth, scrollWidth } = this.elementRef.nativeElement;
    return this.elementClass && offsetWidth < scrollWidth;
  }
}
